export default [
  {
    icon: 'mdi-pencil',
    title: 'Ubah Rencana Kegiatan',
    event: 'onEditRencana',
    akses: 'psp-peserta-pendampingan-lokakarya-dinas.update',
  },
  {
    icon: 'mdi-pencil',
    title: 'Ubah Pelaksanaan Kegiatan',
    event: 'onEditPelaksanaan',
    akses: 'psp-peserta-pendampingan-lokakarya-dinas.update',
  },
  {
    divider: ['psp-peserta-pendampingan-lokakarya-dinas.update', 'psp-peserta-pendampingan-lokakarya-dinas.delete'],
  },
  {
    icon: 'mdi-delete',
    title: 'Hapus Laporan',
    event: 'onDeleteLaporan',
    akses: 'psp-peserta-pendampingan-lokakarya-dinas.delete',
  },
];
